export class Account {
    first_name: string;
    last_name: string;
    username: string;
}
